import { render, staticRenderFns } from "./ManagePricing.vue?vue&type=template&id=47dbbc38&"
import script from "./ManagePricing.vue?vue&type=script&lang=ts&"
export * from "./ManagePricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports